import React from 'react';

export default function SortAscendingIcon ({width = 40, height = 40, fill = '#000'}) {
  return <svg viewBox="0 0 24 24" width={width} height={height}>
    <path fill={fill} d="M10,11V13H18V11H10M10,5V7H14V5H10M10,17V19H22V17H10M6,7H8.5L5,3.5L1.5,7H4V20H6V7Z" />
  </svg>
}
